<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M605 949c145 0 217-97 217-290 0-152-56-275-225-275-112 0-204 73-204 190 0 114 81 191 194 191 50 0 92-20 126-60h1c-1 76-20 162-112 162-45 0-72-20-83-59H415c14 99 98 141 190 141zm-6-825c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528zm4 345c62 0 108 42 108 105s-47 104-109 104c-65 0-106-42-106-106 0-62 46-103 107-103z" />
  </svg>
</template>
